module.exports = __webpack_public_path__ + "img/logo-badge.2456627c.png";